(function () {
  'use strict';

  // Cart count wale saare possible selectors (desktop + mobile + sidebar icons dono cover)
  // NOTE: .ssi__badge class hataya kyunki wishlist badge bhi yahi class use karta hai
  var CART_COUNT_SELECTORS = '.sf-cart-count, .m-cart-count-bubble, #ssi-cart-count';

  function ensureSidebarCartBadge() {
    var cartLink = document.querySelector('a.ssi__item[href="/cart"], a.ssi__item[aria-label="Cart"]');
    if (!cartLink) return null;

    var badge = document.getElementById('ssi-cart-count');
    if (!badge) {
      badge = document.createElement('span');
      badge.id = 'ssi-cart-count';
      badge.className = 'ssi__badge';
      cartLink.appendChild(badge);
    }
    return badge;
  }

  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var count = cart.item_count;

        // Sirf specific cart selectors update karo (wishlist ko chhod ke)
        document.querySelectorAll(CART_COUNT_SELECTORS).forEach(function (el) {
          el.textContent = count;
          if (count > 0) {
            el.classList.remove('hidden');
            el.style.display = 'block';
          } else {
            el.classList.add('hidden');
          }
        });

        // Agar sidebar cart badge exist nahi karta, khud create karo
        var sidebarBadge = ensureSidebarCartBadge();
        if (sidebarBadge) {
          sidebarBadge.textContent = count;
          sidebarBadge.style.display = count > 0 ? 'block' : 'none';
        }
      })
      .catch(function (err) {
        console.warn('Cart count update failed:', err);
      });
  }

  // Jaldi aur guaranteed update ke liye multiple quick retries
  function updateCartCountWithRetries() {
    var delays = [50, 200, 500, 1000];
    delays.forEach(function (delay) {
      setTimeout(updateCartCount, delay);
    });
  }

  var originalFetch = window.fetch;
  window.fetch = function () {
    var fetchPromise = originalFetch.apply(this, arguments);
    var url = arguments[0];
    var urlStr = (typeof url === 'string') ? url : (url && url.url) || '';

    if (urlStr.indexOf('/cart/add') !== -1 || urlStr.indexOf('/cart/change') !== -1 || urlStr.indexOf('/cart/update') !== -1) {
      updateCartCountWithRetries();
    }
    return fetchPromise;
  };

  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1)) {
      this.addEventListener('load', updateCartCountWithRetries);
    }
    return originalOpen.apply(this, arguments);
  };

  document.addEventListener('DOMContentLoaded', updateCartCount);
})();